/**
 * The messaging module's frontend manifest — everything it adds to the
 * interface, in one place. The backend half is `backend/src/modules/messaging/`.
 */
import { MESSAGING_PERMISSIONS } from '@forsys/shared';
import { defineFrontendModule } from '../types';
import MessagePage from './MessagePage';
import MessagesPage from './MessagesPage';
import { MessagesButton } from './MessagesButton';
import { SendMessageButton } from './SendMessageButton';

export const messagingModule = defineFrontendModule({
  key: 'messaging',
  pages: [
    // No `anyOf`: reading your own messages needs a session, not a permission.
    // No menu entry either: the header badge is the way in.
    { path: 'messages', element: <MessagesPage /> },
    { path: 'messages/:id', element: <MessagePage /> },
  ],
  slots: {
    'header.actions': [{ id: 'badge', component: MessagesButton }],
    'user.detail.actions': [{ id: 'send', anyOf: [MESSAGING_PERMISSIONS.SEND], component: SendMessageButton }],
  },
});
